export const ARBITER_TAG = 'pico_arbiter'
export const MENU_TAG = 'pico_menu'
export const LAUNCHER_TAG = 'pico_launcher'
export const PROMPT_TAG = 'pico_prompt'
export const HEADER_TAG = 'pico_header'
export const APP_ERROR_TAG = 'pico_app_error'
